import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UploadedFile } from '@millionshow/client-libs';

@Injectable({ providedIn: 'root' })
export class UploadService {
  async upload(file: File): Promise<UploadedFile> {
    try {
      const formData = new FormData();
      formData.append('files', file);

      const response = await fetch(`${environment.baseUrl}/api/storage`, {
        method: 'POST',
        body: formData,
      });

      const results = await response.json();

      return {
        url: results[0].url,
        filename: results[0].name,
        id: results[0].id,
        size: results[0].size,
      };
    } catch (error) {
      console.error('File upload failed:', error);
      throw new Error('Failed to upload file');
    }
  }

  async delete(url: string): Promise<void> {
    const encodedUrl = encodeURIComponent(url);
    await fetch(`${environment.baseUrl}/api/storage/${encodedUrl}`, {
      method: 'DELETE',
    });

    return;
  }
}
